import { Component, OnInit } from '@angular/core';

/**
 * TODO :: need to fix the problem with tabs and routing and use them instead of defining each tab separatelly
 * in the individual components.
 */
@Component({
    standalone: false,
    selector: 'app-zoning-codes-import-tab',
    templateUrl: './zoning-codes-import-tab.component.html',
    styleUrls: ['./zoning-codes-import-tab.component.scss']

})
export class ZoningCodesImportTabComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
